const columns = [
  {
    title: "#",
    key: "",
    index: true,
  },
  {
    title: "Product Image",
    key: "images",
  },
  {
    title: "Product Name",
    key: "name",
  },
  {
    title: "Category",
    key: "category",
  },
  {
    title: "Sub Category",
    key: "sub_category",
  },
  {
    title: "Expiry Date",
    key: "expiry_date",
    date: true,
    format: "YYYY-MM-DD",
  },
  {
    title: "Near Expire Discount (%)",
    key: "offer_percentage",
    digit: true,
  },
  {
    title: "Regular Discount (%)",
    key: "regular_discount",
    digit: true,
  },
  {
    title: "Uploaded by",
    key: "supplier_name",
  },
  {
    title: "Brand",
    key: "brand",
  },
  {
    title: "Cost",
    key: "cost",
    digit: true,
  },
  {
    title: "Price",
    key: "price",
  },
  {
    title: "Tax (%)",
    key: "tax",
  },
  {
    title: "Barcodes",
    key: "barcodes",
    barcode: true,
  },
  {
    title: "Classification",
    key: "listing_classification",
  },
  {
    title: "Total Sales",
    key: "total_sales",
  },
  {
    title: "Number of Orders",
    key: "orders_count",
  },
  {
    title: "Quantity Sold",
    key: "quantity_sold",
  },
  {
    title: "Stock Inventory",
    key: "quantity",
  },
  {
    title: "Date & Time Added",
    key: "created_at",
    date: true,
  },
];

export default columns;
